import { REFERENCE_CLIENT_LOGOS } from '../lib/siteAssets';

export interface Testimonial {
  id: string;
  organization: string;
  orgFullName: string;
  logoInitials: string;
  logoUrl?: string;
  quote: string;
  name: string;
  title: string;
  year: string;
  active: boolean;
  showOnHome?: boolean;
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    organization: 'İHKİB',
    orgFullName: 'Istanbul Ready-to-Wear & Apparel Exporters\' Association',
    logoInitials: 'İHKİB',
    logoUrl: REFERENCE_CLIENT_LOGOS.ihkib,
    quote: 'Zobu Consulting delivered an outstanding strategic framework for our URGE international competitiveness program. Their command of sectoral dynamics and structured consulting methodology gave us a clear, actionable roadmap that has measurably strengthened the global positioning of Turkish apparel exporters.',
    name: 'Hikmet Tanrıverdi',
    title: 'Secretary General, İHKİB',
    year: '2015',
    active: true,
    showOnHome: true,
  },
  {
    id: '2',
    organization: 'Karaisalı Kaymakamlığı',
    orgFullName: 'Karaisalı District Governorship',
    logoInitials: 'KRS',
    logoUrl: REFERENCE_CLIENT_LOGOS.karaisali,
    quote: 'The socioeconomic development plan crafted by Zobu Consulting gave our district a genuinely transformative vision. Their capacity to blend rigorous data analysis with realistic implementation steps was remarkable — the deliverables set a new standard for development consulting in our region.',
    name: 'Ali Doğan',
    title: 'District Governor, Karaisalı',
    year: '2015',
    active: true,
    showOnHome: true,
  },
  {
    id: '3',
    organization: 'İZKA',
    orgFullName: 'Izmir Development Agency',
    logoInitials: 'İZKA',
    logoUrl: REFERENCE_CLIENT_LOGOS.izka,
    quote: 'Partnering with Zobu Consulting on our regional innovation strategy was a decisive moment for İZKA. Their analytical precision, ability to mobilise diverse stakeholders, and relentless focus on results were exceptional. The strategic outputs they produced continue to steer our regional agenda years later.',
    name: 'Dr. Murat Ersoy',
    title: 'General Secretary, İZKA',
    year: '2010',
    active: true,
    showOnHome: true,
  },
  {
    id: '4',
    organization: 'AKİB',
    orgFullName: 'Mediterranean Exporters\' Associations',
    logoInitials: 'AKİB',
    logoUrl: REFERENCE_CLIENT_LOGOS.akib,
    quote: 'Zobu Consulting equipped our member associations with a comprehensive export strategy that opened new market corridors and dramatically deepened our institutional capacity. Their professionalism, market intelligence, and hands-on engagement throughout the project were simply second to none.',
    name: 'Yusuf Kadıoğlu',
    title: 'Chairman, AKİB',
    year: '2014',
    active: true,
    showOnHome: true,
  },
];
